import React from 'react'
import PropTypes from 'prop-types'

class DtcsHeader extends React.Component {
  state = {
    show: false,
  }

  onToggle = () => {
    this.setState({ show: !this.state.show })
  }

  render() {
    const { dtcs } = this.props
    const { show } = this.state
    const dtcsSelected = dtcs.map((dtc) => dtc.name).join(', ')

    return (
      <div className="relative w-full text-white pl-4">
        <div className="font-medium">
          Mapping {dtcsSelected} for {this.props.vehicleSid}
        </div>
        <div className="underline cursor-pointer" onClick={this.onToggle}>
          {show ? 'Close details' : 'See details'}
        </div>
        {this.state.show && (
          <div className="absolute text-white bg-tracer-lt-blue rounded px-5 mt-3 -ml-6 w-full z-40">
            <div className="max-h-1/2 overflow-auto">
              {dtcs.map((dtc) => (
                <ul key={`dtc-${dtc.id}`}>
                  <li
                    key={dtc.id}
                    className={`w-full py-4 ${
                      dtcs[dtcs.length - 1] !== dtc && 'border-b border-white'
                    } text-white text-sm`}
                  >
                    <div className="flex">
                      <div className="w-1/6 font-bold">{dtc.name}</div>
                      <div className="w-1/6 font-bold">{dtc.acronym}</div>
                      <div className="w-4/6">{dtc.description}</div>
                    </div>
                  </li>
                </ul>
              ))}
            </div>
          </div>
        )}
      </div>
    )
  }
}

DtcsHeader.propTypes = {
  dtcs: PropTypes.array.isRequired,
  vehicleSid: PropTypes.string.isRequired,
}

export default DtcsHeader
